export class discount {
    public id: any;
    public parkId: any;
    public tktTypeId: number;
    public adultCharge: any;
    public childCharge: any;
    public adultDiscount: any;
    public childDiscount: any;
    public createdBy: any;
    public createdOn: any;
    public updatedBy: any;
    public upddatedOn: any;
    public status: any;
    public version: any;
    public customerTypeId: any;

}






// WEBPACK FOOTER //
// ./src/app/markup/markup.ts